module.exports = __webpack_public_path__ + "static/media/Sarajevo-FF-logo-WHITE.1abd1745.png";